import React, { useState, useEffect } from 'react';
import { HelpCircle, X } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import TutorialVideoModal from '../ui/TutorialVideoModal';

const HelpWidget = () => {
    const { isAuthenticated } = useAuth();
    const [isWidgetVisible, setIsWidgetVisible] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);

    // Check if widget was dismissed
    useEffect(() => {
        if (isAuthenticated) {
            const isDismissed = localStorage.getItem('helpWidgetDismissed');
            setIsWidgetVisible(!isDismissed);
        } else {
            setIsWidgetVisible(false);
        }
    }, [isAuthenticated]);

    // Don't render if not authenticated or dismissed
    if (!isAuthenticated || !isWidgetVisible) {
        return null;
    }

    const handleDismiss = () => {
        localStorage.setItem('helpWidgetDismissed', 'true');
        setIsWidgetVisible(false);
    };

    const handleOpenModal = () => {
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    return (
        <>
            {/* Sticky Help Widget */}
            <div className="fixed bottom-6 left-6 z-50 flex flex-col items-start gap-2">
                {/* Main Help Button */}
                <div className="relative group">
                    <button
                        onClick={handleOpenModal}
                        className="flex items-center gap-3 bg-blue-600 hover:bg-blue-700 text-white px-4 py-3 rounded-full shadow-lg hover:shadow-xl transition-all duration-200 hover:scale-105"
                        aria-label="Open tutorial video"
                    >
                        <HelpCircle className="w-6 h-6" />
                        <span className="font-medium text-sm hidden sm:inline">
                            How to use platform?
                        </span>
                    </button>

                    {/* Close button (X) - appears on hover */}
                    <button
                        onClick={handleDismiss}
                        className="absolute -top-2 -right-2 bg-gray-800 hover:bg-gray-900 text-white rounded-full p-1 opacity-0 group-hover:opacity-100 transition-opacity shadow-md"
                        aria-label="Dismiss help widget"
                    >
                        <X className="w-4 h-4" />
                    </button>
                </div>

                {/* Tooltip hint (optional - shows on first appearance) */}
                <div className="hidden sm:block bg-gray-900 text-white text-xs px-3 py-2 rounded-lg shadow-lg max-w-xs animate-pulse">
                    👋 New here? Watch our quick tutorial!
                </div>
            </div>

            {/* Video Modal */}
            <TutorialVideoModal isOpen={isModalOpen} onClose={handleCloseModal} />
        </>
    );
};

export default HelpWidget;
